module.exports = __webpack_public_path__ + "img/google_ads_icon.76dbcd82.svg";